import superagent from '@ott/superagent';

import { prepareDeals } from './dealsAdapter';
import { getQueryByProduct } from './prepareQuery';
import getHapiGeo from './getHapiGeo';

import { PRODUCTS, TYPES } from '../constants';

const endpointByProduct = {
  [PRODUCTS.avia]: '/_avia/deals_v4/directApiTop',
  [PRODUCTS.poezda]: '/_mark/deals/railways',
  [PRODUCTS.hotels]: '/_hotels/api/deals',
  [PRODUCTS.bundles]: '/_bundles/deals',
  [PRODUCTS.cars]: '/_cars/popular',
};

const DEFAULT_TIMEOUT = 158000;

const getDeals = async ({
  endpointUrl,
  product,
  from,
  getHref,
  staticDeals,
  referrer,
  currency,
  locale,
  limit,
}) => {
  let dynamicDeals = null;

  if (!staticDeals) {
    const query = getQueryByProduct(product, from, referrer, currency, locale, limit);
    try {
      const { body: response } = await superagent
        .get(endpointUrl || endpointByProduct[product])
        .query(query)
        .timeout(DEFAULT_TIMEOUT);

      if (response.error) {
        return Promise.reject(response);
      }

      if (product === PRODUCTS.bundles) {
        const geo = await getHapiGeo(response);

        dynamicDeals = {
          deals: response,
          geo,
        };
      } else {
        dynamicDeals = response;
      }
    } catch (error) {
      return Promise.reject(error);
    }
  }

  const deals = dynamicDeals || staticDeals;

  const items = prepareDeals(deals, product, getHref, !!staticDeals).map((deal) => ({
    ...deal,
    type: TYPES.deal,
  }));

  return {
    items,
  };
};

export default getDeals;
